export enum ViewSlotsMode {
  booking = 'booking',
  preview = 'preview',
}
